// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+ihpa","footer":"Footer_footer__PxxIj","copy":"Footer_copy__NeIYV"};